import { render, staticRenderFns } from "./sample-report.vue?vue&type=template&id=8a0eb706&"
import script from "./sample-report.vue?vue&type=script&lang=js&"
export * from "./sample-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports